import { CrmLayoutMain } from './crm-layout-main';
import { CrmLayoutNote } from './crm-layout-note';
import { CrmLayoutRoot } from './crm-layout-root';

export const CrmLayout = {
  Root: CrmLayoutRoot,
  Main: CrmLayoutMain,
  Note: CrmLayoutNote,
};
